import { getUrlParameter } from './helpers';
import stateAbbreviations from 'states-abbreviations';

export function formUtils() {
  $('.gfield.has-float-label input, .gfield.has-float-label textarea').on('focus blur', function(e) {
    if (e.type === 'focus') {
      $(this).parents('.gfield.has-float-label').addClass('in');
    } else {
      $(this).parents('.gfield.has-float-label').removeClass('in');

      if ($(this).val()) {
        $(this).parents('.gfield.has-float-label').addClass('has-value');
      } else {
        $(this).parents('.gfield.has-float-label').removeClass('has-value');
      }
    }
  });

  if (getUrlParameter('v').length) {
    if ($('option[value="' + getUrlParameter('v') + '"]')) {
      $('option[value="' + getUrlParameter('v') + '"]').each(function() {
        $(this).parent().val(getUrlParameter('v')).attr('selected', 'selected');
      });
    }

    if ($('.address_state > input').length) {
      console.log();
      $('.address_state > input').val(stateAbbreviations[getUrlParameter('v')]);
    }
  }
}
